( function ( $ ) {
	$( function () {
		//console.log( 'opts', ccfaaOpts );
		var emailButton = document.getElementById( 'email-ccfaa' );
		document.getElementById( 'ccfaa-response' ).innerText = '(not sent)';
		if ( '' !== ccfaaOpts.sent ) {
			emailButton.setAttribute( 'disabled', 'disabled' );
			document.getElementById( 'ccfaa-response' ).innerText = 'Sent on ' +
				ccfaaOpts.sent;
		}
		emailButton.addEventListener( 'click', e => {
			e.preventDefault();
			let resp = document.getElementById( 'ccfaa-spinner' );
			resp.classList.add( 'lds-ring' );
			var target = e.target;
			//console.log( 'target', target );
			var file_path = target.dataset.birthdayfile;
			//console.log( 'file_path', file_path );
			var data = {
				'action': 'email_ccfaa',
				'file_path': file_path,
			};
			var ajaxUrl = ccfaaOpts.ajaxUrl;
			//console.log( 'ajaxUrl', ajaxUrl );

			jQuery.ajax( {
				type: 'POST',
				dataType: 'json',
				url: ajaxUrl,
				data: data,
				success: function ( response ) {
					console.log( 'response', response );
					document.getElementById( 'ccfaa-spinner' ).
					         classList.
					         remove( 'lds-ring' );
					var change = document.getElementById( 'ccfaa-response' );
					if ( response.success ) {
						change.innerText = response.data;
						console.log( 'sent' );
					} else {
						change.innerText = response.data;
						console.log( 'not sent' );
					}
				},
			} );

		} );
	} );
}( jQuery ) );
